module.exports = __webpack_public_path__ + "static/media/truemoney_desktop.527c019d.png";